import React from 'react'
import styled from 'styled-components'
import Header from '~/components/card/header'
import Handle from '~/prix/react/components/handle'
import useAPI from '~/prix/react/hooks/api'
import { canListUsers } from './userManagementPermissions'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: 870px) {
    padding: 30px 0;
  }
`

const Container = styled.div`
  padding: ${({ theme }) => theme.padding(2)};
  background-color: #fff;
  margin-bottom: 1rem;
  border-bottom-left-radius: ${({ theme }) => theme.borderRadius};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius};
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
`

const Message = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.darkGrey};
  font-size: 14px;
`

export default function UserManagementAccessGuard({ children }: { children: React.ReactNode }) {
  const { context, isLoading } = useAPI()
  const actorRole = context.user?.activeClient?.roles?.[0]

  if (isLoading) {
    return (
      <Handle isLoading style={{ height: '100%' }}>
        <div />
      </Handle>
    )
  }

  if (!canListUsers(actorRole)) {
    return (
      <Wrapper>
        <Header title='Acesso não autorizado' />
        <Container>
          <Message>Você não tem permissão para gerenciar usuários.</Message>
        </Container>
      </Wrapper>
    )
  }

  return <>{children}</>
}
